// ============================================================================
// FRENCH TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
  title: "L'Unité qui Produit la Paix",
  author: "Par Emmanuel",
  subtitle: "Chaque religion a ses raisons, nos frontières viennent du passé",
  description: "Module de réflexion sur l'unité spirituelle et la paix entre les traditions",
  
  nav: {
    intro: "Intro",
    religions: "Religions",
    common: "Bases Communes",
    humility: "Humilité"
  },

  intro: {
    emmanuelSays: "Emmanuel dit :",
    ourBordersFromPast: "Nos frontières viennent du passé",
    bordersDescription: "Chaque religion a ses raisons. Nos divisions ne sont pas la volonté divine, mais le fruit de l'histoire, de la géographie, de la culture.",
    divisionWork: "La division, l'isolement par des barrières et frontières de peur, est l'œuvre de notre passé périlleux.",
    sharedHumanity: "Nous sommes nés dans des traditions différentes, mais nous partageons la même humanité.",
    
    revelationTitle: "Une révélation qui ouvre les yeux",
    surprisedLearning: "J'ai été surpris un jour en apprenant que les Juifs sont aussi les fils de Dieu.",
    angelMichael: "Que l'ange Michel est un grand messager pour les musulmans.",
    jesusNames: "Que Jésus, Isa, Yeshua sont connus de diverses manières, même dans la foi chrétienne.",
    diverseTribes: "Car il existe diverses tribus, diverses églises, diverses familles.",
    sameRealities: "Nous parlons des mêmes réalités avec des noms différents. Cela devrait nous rapprocher, pas nous diviser.",
    
    respectTitle: "Le respect : socle de l'humilité, gardien de la paix",
    respectFoundation: "Même si la fraternité n'est pas applicable objectivement, le respect est le socle de l'humilité, gardien de la paix.",
    understandingProcess: "Comprendre et respecter les autres religions est un processus d'humilité. Cela ne veut pas dire renoncer à sa foi, mais accepter que l'autre aussi cherche la vérité.",
    
    whatBindsUs: "Ce qui nous lie vraiment",
    seekingRelation: "Chaque religion cherche la relation. Chaque homme recherche la paix.",
    loveOfGod: "Cette relation qui nous lie tous, c'est l'amour de Dieu.",
    universalLink: "L'amour est le lien universel qui transcende toutes les frontières, toutes les langues, toutes les traditions.",
    
    inclusionTitle: "L'inclusion : plus vaste encore que la diversité religieuse",
    vastInclusion: "La diversité religieuse est vaste, mais encore plus vaste est l'inclusion des autres là où ils sont appelés par Dieu.",
    respectDifferences: "Le respect des différences de couleur, de genres, l'inclusion nous rend humains uniques, aimés de Dieu.",
    jesusCommand: "Jésus a dit : 'Aimez-vous les uns les autres.'",
    
    communitySpirit: "Rompre avec l'esprit communautariste",
    communityTerror: "Le communautarisme est le terrot de la haine du mal déguisé. Il transforme la foi en identité tribale, en mur qui sépare, en arme qui blesse.",
    pridePolitics: "Nos esprits de parti nous poussent à la politique de l'orgueil :",
    prideQuotes: "J'ai raison de te faire mal. J'ai raison un point c'est tout. J'ai raison de faire bonne guerre.",
    watchHeart: "Prenez garde au cœur du problème, à la racine de notre propre mal.",
    refuseDivision: "Refusons cette dérive qui divise l'humanité au nom de Dieu.",
    
    freedomTitle: "Pour être libres, rendre libres les autres",
    freedomOthers: "Pour être libres, il faut savoir rendre libres les autres aussi.",
    defendFreedom: "Ma liberté de croire n'a de valeur que si je défends celle de tous. Opprimer l'autre, c'est me condamner moi-même à la servitude.",
    
    changeHeartTitle: "Change ton cœur : sois une vraie lanterne",
    recognizeDecency: "Reconnaître que la bienséance n'est pas la même pour chacun.",
    changeYourself: "Changement de toi d'abord, progressivement. Change ton cœur, transforme ta vie, sois une vraie lanterne.",
    beExample: "Tu feras pas pipi sur le gazon, car il périra... Ne pas imposer tes règles aux autres, mais devenir un exemple vivant par ta transformation.",
    
    childrenPeaceTitle: "Nos enfants vivront en paix dans la diversité",
    avoidPursuit: "Éviter la poursuite des mots pour mots.",
    peaceChoice: "Si nous choisissons le respect aujourd'hui, nos enfants du futur vivront en paix dans la diversité. La paix commence par nous, maintenant, dans nos paroles et nos actes.",
    
    discernTitle: "Discerner : l'homme ou Dieu ?",
    manSpeaks: "Trop de fois, c'est le cœur de l'homme qui parle et divise.",
    seeFruits: "On le voit par le fruit des paroles et des mots : le vol, la destruction, les guerres. Prenez garde à la manipulation des mots pour concourir à son propre orgueil.",
    
    lookPeaceTitle: "Regarder à la paix et à l'amour",
    lookPeaceAll: "Regarder à la paix pour tous, regarder à l'amour de Dieu pour les autres.",
    godSpeaks: "Quand les mots produisent la paix, la réconciliation, l'unité : c'est Dieu qui parle. Quand ils produisent la division, la haine, la guerre : c'est l'orgueil de l'homme.",
    
    watchWordsTitle: "Veiller à nos mots",
    watchShares: "Veiller à nos partages, veiller à nos mots contraires néfastes envers les autres.",
    disqualify: "Ces maux nous disqualifient nous-mêmes. Les fruits de nos paroles révèlent qui parle en nous : Dieu ou notre propre orgueil ?",
    
    wisdomMaturityTitle: "Sagesse et maturité face à notre nature",
    useScriptures: "Utiliser les écritures (les lois) pour faire mal est notre habitude, un processus presque naturel et espiègle.",
    hateSin: "Face à notre nature pécheresse, nous avons en horreur le mal et les personnes qui font le mal.",
    separateActs: "Mais par sagesse et maturité, il faut séparer les actes de notre pauvreté humaine.",
    compassionNature: "Reconnaître notre nature animale qui a besoin de compassion et de grâce, tout en se protégeant selon les contextes.",
    
    denounceLeadersTitle: "Dénoncer les leaders spirituels corrompus",
    watchLeaders: "Prenez garde aux leaders spirituels ou dirigeants qui cherchent à garder en secret leur dérive et malhonnèteté.",
    noJustice: "Sans justice, pas d'exemple. Sans connaissance, d'autres victimes périssent par notre silence.",
    silenceComplicity: "Le silence face à l'injustice est une complicité. La vérité doit être dite pour protéger les autres."
  },

  religions: {
    title: "Diverses Religions, une Humanité",
    intro: "Chrétiens, Musulmans, Juifs, Hindous, Bouddhistes... et bien d'autres : tous cherchent la vérité",
    theirGod: "Leur Dieu :",
    theGood: "Le Bien :",
    theEvil: "Le Mal :",
    theAngels: "Les Anges :",
    theUnity: "L'Unité :",
    values: "Valeurs :",
    commonGoal: "Objectif Commun",
    seekingPeace: "Toutes les religions partagent un objectif commun : rechercher la paix, promouvoir l'amour et construire un monde meilleur. Au-delà de nos différences, nous sommes tous unis dans cette quête de sagesse et d'harmonie.",
    
    christianity: {
      name: "Christianisme",
      godText: "Un Dieu unique, Père créateur",
      goodText: "L'amour du prochain, le pardon, la paix",
      evilText: "La haine, l'égoïsme, la violence",
      angelsText: "Les messagers de Dieu (Gabriel, Michel...)",
      unityText: "Un seul Dieu pour tous les hommes",
      values: "Amour,Pardon,Paix,Humilité,Justice"
    },
    islam: {
      name: "Islam",
      godText: "Allah, l'Unique et Miséricordieux",
      goodText: "La justice, la charité, la paix",
      evilText: "L'oppression, le mensonge, la division",
      angelsText: "Les anges de lumière (Jibril, Mikail...)",
      unityText: "Il n'y a de dieu qu'Allah",
      values: "Paix,Justice,Charité,Respect,Miséricorde"
    },
    judaism: {
      name: "Judaïsme",
      godText: "YHWH, l'Éternel unique",
      goodText: "La justice, la compassion, la vie",
      evilText: "L'oppression, la médisance, la haine",
      angelsText: "Les messagers célestes (Malakhim)",
      unityText: "Écoute Israël, l'Éternel est Un",
      values: "Justice,Vie,Mémoire,Paix,Étude"
    },
    hinduism: {
      name: "Hindouisme",
      godText: "Brahman, la réalité suprême",
      goodText: "La non-violence (ahimsa), le devoir juste",
      evilText: "La violence, l'ignorance spirituelle",
      angelsText: "Les Devas, êtres célestes bienveillants",
      unityText: "Tout est Un dans Brahman",
      values: "Non-violence,Vérité,Compassion,Pureté,Harmonie"
    },
    buddhism: {
      name: "Bouddhisme",
      godText: "Pas de dieu créateur, mais respect du sacré",
      goodText: "La compassion, la sagesse, la paix",
      evilText: "La souffrance causée par l'ignorance",
      angelsText: "Les Bodhisattvas, êtres éveillés",
      unityText: "Nature de Bouddha en chacun",
      values: "Compassion,Sagesse,Paix,Non-violence,Éveil"
    }
  },

  common: {
    title: "Les Bases Communes",
    intro: "Le Bien, le Mal, les Anges, Un Dieu Unique, la Relation, l'Inclusion : ce qui unit l'humanité",
    
    goodTitle: "Le Bien",
    goodDescription: "Toutes les religions enseignent l'amour, la justice et la compassion",
    goodExamples: "Aimer son prochain comme soi-même|Faire le bien sans distinction|Protéger les faibles et les opprimés|Dire la vérité avec bienveillance|Partager ce que l'on a",
    
    evilTitle: "Le Mal",
    evilDescription: "Toutes condamnent la violence, le mensonge et l'oppression",
    evilExamples: "Tuer sans justice|Voler et exploiter|Mentir et calomnier|Mépriser et humilier|Diviser et haïr",
    
    angelsTitle: "Les Anges et Êtres Spirituels",
    angelsDescription: "Presque toutes reconnaissent des messagers célestes bienveillants",
    angelsExamples: "Anges messagers de Dieu|Guides spirituels|Êtres de lumière|Protecteurs célestes|Bodhisattvas et Devas",
    
    godTitle: "Un Dieu Unique (ou Réalité Suprême)",
    godDescription: "La majorité croit en une source unique, un créateur ou une réalité ultime",
    godExamples: "Christianisme, Islam, Judaïsme : Un seul Dieu|Hindouisme : Brahman, l'Un suprême|Bouddhisme : Nature de Bouddha universelle|Tous cherchent la vérité ultime|Tous aspirent à l'unité et à la paix",
    
    relationTitle: "La Relation et la Paix",
    relationDescription: "Ce qui unit vraiment toutes les religions et tous les hommes",
    relationExamples: "Chaque religion cherche la relation avec le divin|Chaque homme recherche la paix|Cette relation qui nous lie tous, c'est l'amour de Dieu|L'amour est le lien universel|La paix est notre aspiration commune",
    
    inclusionTitle: "L'Inclusion : Aimés de Dieu",
    inclusionDescription: "La diversité religieuse est vaste, mais encore plus vaste est l'inclusion",
    inclusionExamples: "Inclusion des autres là où ils sont appelés par Dieu|Respect des différences de couleur|Respect des différences de genres|L'inclusion nous rend humains uniques, aimés de Dieu|Jésus a dit : 'Aimez-vous les uns les autres'",
    
    finalQuote: "J'ai été surpris un jour en apprenant que les Juifs sont aussi les fils de Dieu, que l'ange Michel est un grand messager pour les musulmans, que Jésus, Isa, Yeshua sont connus de diverses manières même dans la foi chrétienne. Car il existe diverses tribus, diverses églises, diverses familles.",
    finalQuote2: "Nous parlons des mêmes réalités avec des noms différents.",
    quoteAuthor: "Emmanuel, L'Unité qui Produit la Paix"
  },

  humility: {
    title: "7 Étapes vers l'Humilité et la Paix",
    intro: "Le processus pour dépasser le communautarisme et devenir une vraie lanterne",
    
    step: "Étape",
    action: "Action :",
    
    step1Title: "Reconnaître : nos frontières viennent du passé",
    step1Description: "La division, l'isolement par des barrières et frontières de peur, est l'œuvre de notre passé périlleux. Nos divisions ne sont pas la volonté de Dieu.",
    step1Action: "Accepter que ma tradition n'est qu'à moi, et je fais partie de la diversité voulue par Dieu",
    
    step2Title: "Le respect : socle de l'humilité, gardien de la paix",
    step2Description: "Même si la fraternité n'est pas applicable objectivement, le respect est le fondement.",
    step2Action: "Respecter toutes les croyances, même sans tout comprendre",
    
    step3Title: "Comprendre sans juger",
    step3Description: "Aujourd'hui, comprendre les autres est un processus d'humilité nécessaire.",
    step3Action: "Écouter vraiment ce que croient les autres, sans jugement",
    
    step4Title: "Changement de toi d'abord : sois une vraie lanterne",
    step4Description: "Reconnaître que la bienséance n'est pas la même pour chacun. Change ton cœur progressivement, transforme ta vie, deviens une vraie lumière.",
    step4Action: "Ne pas imposer mes règles aux autres, mais être un exemple vivant par ma transformation",
    
    step5Title: "Rompre avec l'esprit communautariste",
    step5Description: "Nos esprits de parti nous poussent à la politique de l'orgueil : 'J'ai raison de te faire mal, j'ai raison un point c'est tout.' Prenez garde au cœur du problème, à la racine de notre propre mal.",
    step5Action: "Refuser les discours de division dans ma propre communauté",
    
    step6Title: "Pour être libre, rendre libre les autres",
    step6Description: "Ma liberté dépend de celle que j'accorde aux autres.",
    step6Action: "Défendre la liberté de conscience de tous, pas seulement la mienne",
    
    step7Title: "Éviter la poursuite des mots pour mots",
    step7Description: "Ne pas répondre à la haine par la haine, aux insultes par les insultes.",
    step7Action: "Choisir la paix pour que nos enfants vivent en paix dans la diversité",
    
    discernFruits: "Discerner par les Fruits",
    humanHeart: "Le cœur de l'homme qui divise",
    lookGodLove: "Regarder à l'amour de Dieu",
    watchOurWords: "Veiller à nos Mots",
    
    prideFruits: "Fruits de l'orgueil humain",
    prideFruitsList: "L'esprit de parti : \"J'ai raison un point c'est tout\"|La politique de l'orgueil : \"J'ai raison de te faire mal\"|Utiliser les écritures pour faire mal (processus espiègle)|Avoir en horreur les personnes (et non seulement les actes)|Leaders spirituels qui cachent leur dérive et malhonnêteté|Silence complice face à l'injustice|Division et guerres|Haine déguisée en piété|Vol et destruction|Manipulation pour l'orgueil|Mépris et violence",
    
    godFruits: "Fruits de l'amour de Dieu",
    godFruitsList: "Séparer les actes de la personne avec sagesse|Compassion pour notre pauvreté humaine|Grâce tout en se protégeant selon les contextes|Dénoncer l'injustice pour protéger les autres|Dire la vérité avec courage|Paix pour tous|Amour sans distinction|Réconciliation et unité|Humilité et respect|Liberté pour tous",
    
    finalQuote: "Même si la fraternité n'est pas applicable objectivement, le respect est le socle de l'humilité, gardien de la paix. Éviter la poursuite des mots pour mots, et nos enfants du futur vivront en paix dans la diversité.",
    author: "Emmanuel"
  },

  footer: {
    quote: "Le respect est le socle de l'humilité, gardien de la paix. Nos enfants vivront en paix dans la diversité si nous choisissons le respect aujourd'hui.",
    author: "Emmanuel, L'Unité qui Produit la Paix"
  }
};

export default unityTranslations;
